<template>
  <v-card
    class="mx-auto EK-card light pb-0 rounded-xl rounded-tr-0 mainTheme mainLabelsColor overflow-hidden text-right"
  >
    <v-card-title class="justify-content-center pb-0 pt-2">
        <strong class="m-auto">تحديد الاحداثيات</strong>
        <v-btn @click="$emit('close')" depressed icon>
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pt-3 pb-3">
        <v-col>
            <v-row>
                <v-text-field
                    id="searchPlace"
                    rounded
                    dense
                    solo
                ></v-text-field>
                <div id="map" style="width: 100%; height: 400px"></div>
            </v-row>
        </v-col>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="justify-content-center">
      <v-btn @click="sendLatLng" color="success" rounded class="by-5 px-10 rounded-tr-0"> تم </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style lang="scss">
.gm-style {
    div:first-of-type {
        cursor: pointer!important;
    }
}
</style>
<script>
import { Loader } from "@googlemaps/js-api-loader";
export default {
  data: () => ({
    myLatlng: {},
    zoom:13,
    shopId: Number,
    map: null,
    markers: [],
    lat:null,
    lng: null,
    notyTitle: [(v) => !!v || "يرجى اختيار عنوان للإشعار"],
    notyDesc: [(v) => !!v || "يرجى اختيار نص للإشعار"],
  }),
  props: {
    latProp: String,
    lngProp: String,
  },
  created() {
    this.initMap();
  },
  methods: {
    initMap() {
        this.lat = parseFloat(this.latProp)
        this.lng = parseFloat(this.lngProp)
        if (isNaN(this.lat) || isNaN(this.lng)) {
            this.myLatlng = { lat: 36.204, lng: 37.135 }
        } else {
            this.myLatlng = { lat: this.lat, lng: this.lng }
            this.zoom = 13
        }
        const loader = new Loader({
            apiKey: "AIzaSyCAke055qbFvoFY57TIDmCF7oX8_XoooxA",
            version: "weekly",
            libraries: ["places"]
        })
        loader.load().then(() => {
            this.map = new google.maps.Map(document.getElementById("map"), {
                center: this.myLatlng,
                zoom: this.zoom,
                minZoom: 3,
                mapTypeId: "roadmap"
            })
            const input = document.getElementById('searchPlace')
            const searchBox = new google.maps.places.SearchBox(input)
            this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(searchBox);
            searchBox.addListener("bounds_changed", () => {
                const places = searchBox.getPlaces();
            })
            
            searchBox.addListener("places_changed", () => {
                const places = searchBox.getPlaces();
                if (places.length == 0) {
                    return;
                }
                const bounds = new google.maps.LatLngBounds();
                places.forEach((place) => {
                    if (!place.geometry || !place.geometry.location) {
                        console.log("Returned place contains no geometry");
                        return;
                    }
                    if (place.geometry.viewport) {
                        bounds.union(place.geometry.viewport);
                    } else {
                        bounds.extend(place.geometry.location);
                    }
                });
                this.map.fitBounds(bounds);
            })
            this.addMarker(this.myLatlng, this.map)
            this.map.addListener("click", (event) => {
                this.addMarker(event.latLng, this.map)
                this.lat = event.latLng.toJSON().lat.toString()
                this.lng = event.latLng.toJSON().lng.toString()
            })
        })
    },
    addMarker(location, map, label) {
        if (this.markers.length != 0) {
            this.markers[0].setMap(null);
            this.markers = [];
        }
        const marker = new google.maps.Marker({
            position: location,
            map: map,
        });
        this.markers.push(marker);
    },
    sendLatLng() {
        this.$emit("getLatLng", this.lat, this.lng);
        this.$emit("close");
    },
  },
}
</script>
